import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { BoardCard } from './BoardCard';
import { GTMProject } from '../../types/pipeline';

interface DraggableBoardCardProps {
  project: GTMProject;
  onClick: (project: GTMProject) => void;
}

export const DraggableBoardCard: React.FC<DraggableBoardCardProps> = ({ project, onClick }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id: project.id });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={isDragging ? 'opacity-40' : ''}
    >
      <BoardCard project={project} onClick={onClick} />
    </div>
  );
};
